export const makeName = (user: { firstName?: string; lastName?: string }): string => {
  return [user.firstName, user.lastName].filter(s => s).join(" ");
};
